<template>
  <path
    d="M11.5 9L6 2.5L0.5 8.99996"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
